export const MINUTE_IN_SECONDS = 60;
export const HOUR_IN_SECONDS = 3600;
export const DAY_IN_SECONDS = 86400;
export const SECOND = 1000;
export const MINUTE = SECOND * MINUTE_IN_SECONDS;
